import { t } from "../lib/i18n";
import React from 'react';

interface OverduePaymentsSectionProps {
  payments: any[];
}

const OverduePaymentsSection: React.FC<OverduePaymentsSectionProps> = ({
  payments = [],
}) => {
  return (
    <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary">
      <h3 className="text-xl font-bold mb-4 text-text-secondary">{t("overduePaymentsSection.k1")}</h3>
      {payments.length > 0 ? (
        <div className="space-y-3">
          {payments.map((payment, index) => (
            <div key={index} className="flex items-center justify-between bg-bg-tertiary p-3 rounded-lg border border-border-secondary">
              <div className="flex flex-col">
                <span className="text-lg font-semibold text-text-primary">${payment.amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                <span className="text-sm text-text-secondary">{t("overduePaymentsSection.k2")} {new Date(payment.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</span>
              </div>
              <div className="text-right">
                <span className="text-sm font-medium text-text-tertiary">{t("overduePaymentsSection.k3")} {payment.leases?.custom_id || payment.lease_id}</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-text-secondary">{t("overduePaymentsSection.k4")}</p>
      )}
    </div>
  );
};

export default OverduePaymentsSection;
